import { Box, Typography, MenuItem, styled } from '@mui/material'

export const StyledBox = styled(Box)({
  width: '100%',
  maxWidth: '1500px',
  margin: '0 auto'
})

export const StyledMenuItem = styled(MenuItem)(({ theme }) => ({
  justifyContent: 'center',
  padding: '12px 10px',
  fontWeight: 500,
  transition: 'color 0.3s ease',
  '&:hover': { color: '#e20613' }
}))

export const BrandName = styled(Typography)(({ theme }) => ({
  fontSize: '13px',
  fontWeight: 700,
  textTransform: 'uppercase',
  color: theme.palette.fontColor.dark,
  letterSpacing: '0.02em'
}))

export const ProductName = styled(Typography)(({ theme }) => ({
  fontSize: '18px',
  lineHeight: '1.55',
  fontWeight: 500,
  display: '-webkit-box',
  WebkitBoxOrient: 'vertical',
  overflow: 'hidden'
}))

export const DiscountLabel = styled(Typography)(({ theme }) => ({
  position: 'relative',
  top: '10px',
  left: '10px',
  width: 'fit-content',
  backgroundColor: theme.palette.accent.main,
  color: theme.palette.primary.main,
  padding: '4px 10px',
  fontSize: '10.5px',
  fontWeight: 700,
  borderRadius: '999px',
  textTransform: 'uppercase',
  letterSpacing: '0.03em'
}))

export const StockLabel = styled(Typography)(({ theme }) => ({
  position: 'relative',
  width: 'fit-content',
  backgroundColor: 'rgba(0, 170, 0, 0.1)',
  color: theme.palette.success.main,
  padding: '4px 10px',
  fontSize: '13px',
  fontWeight: 600,
  borderRadius: '999px'
}))
